import { render, staticRenderFns } from "./ContractSelectingProvider2.vue?vue&type=template&id=6453b6d7&scoped=true&lang=pug&"
import script from "./ContractSelectingProvider2.vue?vue&type=script&lang=ts&"
export * from "./ContractSelectingProvider2.vue?vue&type=script&lang=ts&"
import style0 from "./ContractSelectingProvider2.vue?vue&type=style&index=0&id=6453b6d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453b6d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VSelect,VTextField})
